import { LeadFormPage } from './lead-form'
import { OrderConfirmedPage } from '../order/order-confirmed/order-confirmed'

export const LeadGenerationStack = {
  LeadFormPage,
  LeadFormSuccessPage: OrderConfirmedPage,
}
